import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { UserService } from "../../providers/session-service/user-service";
import { HomePage } from "../home/home";
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html',
})
export class SettingsPage {

    constructor(private userService: UserService, public af: AngularFireAuth) {
        
    }

    changePassword() {
        this.af.auth.sendPasswordResetEmail(this.userService.getUser().email).then(resp => {
            this.userService.createToast('Ένας σύνδεσμος αλλαγής κωδικού θα αποσταλεί στο email σας.');
        }).catch(error => {
            this.userService.createToast('Δεν ήταν δυνατή η αποστολή του email.');
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts